import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Col, Row, Button, Input, notification, Form,
} from 'antd';
import './ChangePassword.scss';
import NewPassword from '../sharedComponents/newPassword/NewPassword';
import {
  put, isSuperAgentError, RequestWrapper, ResponseWrapper,
} from '../../dataSource/requests';

const ChangePassword = (): JSX.Element => {
  interface ChangePasswordForm {
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
  }

  const navigate = useNavigate();
  const [formInstance] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (values: ChangePasswordForm): Promise<void> => {
    setLoading(false);

    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    if (values.oldPassword === values.newPassword) {
      notification.error({
        message: 'Senha em uso',
        description: 'Informe uma senha diferente da atual.',
      });
      setLoading(false);
      return;
    }

    try {
      const requestReference: RequestWrapper = put({
        url: '/user/updatePassword',
        params: values,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      setLoading(true);

      response = await requestReference;
    } catch (error) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      } else {
        genericError = error as Error;
      }
    }

    switch (true) {
      case (response?.body?.code === 1005):
        // "User password updated successfully", 1005
        notification.success({
          message: 'Sucesso',
          description: 'Senha alterada.',
        });

        navigate('/');
        break;

      case (responseError?.body?.code === -1006):
        // "Invalid old password", -1006
        notification.error({
          message: 'Senha incorreta',
          description: 'Digite a senha antiga corretamente para poder cadastrar uma nova senha.',
        });
        break;

      case (responseError?.body?.code === -1007):
        // "User not found", -1007
        notification.error({
          message: 'Usuário não encontrado',
          description: 'Ocorreu um erro ao atualizar a senha.',
        });
        break;

      case (genericError?.message?.includes('has been aborted')):
        // dont show anything when request is aborted
        break;

      default:
        notification.error({
          message: 'Erro',
          description: 'Ocorreu um erro ao atualizar a senha.',
        });
        break;
    }

    setLoading(false);
  };

  const validateToNextPassword = (_rule: any, value: string): Promise<void | Error> => {
    if (value && value.length < 6) {
      return Promise.reject(new Error('A senha deve conter pelo menos 6 caracteres.'));
    }

    return Promise.resolve();
  };

  return (
    <div className="ChangePassword">
      <div className="default-page-title">Alterar senha</div>
      <div className="page-content">
        <Form.Provider>
          <Form
            scrollToFirstError
            layout="vertical"
            form={formInstance}
            name="oldPasswordForm"
            onFinish={handleSubmit}
            onFinishFailed={
              (errorInfo): void => {
                console.log('onFinishFailed', errorInfo);
              }
            }
          >
            <Row
              gutter={24}
              style={{ margin: '0px' }}
            >
              <Col
                xs={{ span: 24 }}
                lg={{ span: 12, offset: 6 }}
                style={{ padding: '0px' }}
              >
                <Form.Item
                  label="Senha atual"
                  name="oldPassword"
                  rules={[
                    {
                      required: true, message: 'Por favor, insira sua senha atual',
                    },
                    {
                      validator: validateToNextPassword,
                    },
                  ]}
                >
                  <Input
                    autoComplete="password"
                    name="password"
                    type="password"
                    placeholder="Senha atual"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <NewPassword form={formInstance} vertical={1} />
              </Col>
            </Row>

            <Form.Item
              className="btn-container"
            >
              <Row
                gutter={24}
                style={{ margin: '0px' }}
              >
                <Col
                  xs={{ span: 24 }}
                  lg={{ span: 12, offset: 6 }}
                  style={{ padding: '0px' }}
                >
                  <Form.Item
                    noStyle
                  >
                    <Button
                      style={{ width: '100%' }}
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                    >
                      ENVIAR
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
              <Row
                gutter={24}
                style={{ margin: '0px' }}
              >
                <Col
                  xs={{ span: 24 }}
                  lg={{ span: 12, offset: 6 }}
                  style={{ padding: '0px' }}
                >
                  <Button
                    style={{ width: '100%' }}
                    onClick={
                      (): void => {
                        navigate('/');
                      }
                    }
                  >
                    CANCELAR
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </Form>
        </Form.Provider>
      </div>
    </div>
  );
};

ChangePassword.propTypes = {};
ChangePassword.defaultProps = {};

export default ChangePassword;
